import { loadable } from '@shared/core/loadableFromNamedExport';

/** Code-split entry for the Polaroid motion type; loads only when Motion resolves on. */
export const LazyPolaroid = loadable(() => import(/* webpackChunkName: "content/guest/header/motion/polaroid" */ './Polaroid'), 'Polaroid');
